import { defaultManufacturers } from './default-manufacturers-en.i18n';

export const en = {
  defaultManufacturers,
};
